import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { TechStack } from './components/TechStack';
import { Features } from './components/Features';
import { Pricing } from './components/Pricing';
import { Cases } from './components/Cases';
import { Footer } from './components/Footer';
import { FloatingMessengers } from './components/FloatingMessengers';
import { SEOUpdater } from './components/SEOUpdater';
import { useSiteData } from './context/SiteContext';
import { LazyMotion, domAnimation } from 'framer-motion';

function App() {
  const { loading, error } = useSiteData();

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center bg-[#0f172a]"><p className="text-xl text-slate-500">Загрузка...</p></div>;
  }

  if (error) {
    return <div className="min-h-screen flex items-center justify-center bg-[#0f172a]"><p className="text-xl text-red-500">{error}</p></div>;
  }

  return (
    <LazyMotion features={domAnimation} strict>
      <div className="min-h-screen bg-[#0f172a] selection:bg-accent/20 selection:text-accent">
        <SEOUpdater />
        <Header />
        <main>
          <Hero />
          <TechStack />
          <Features />
          <Pricing />
          <Cases />
        </main>
        <Footer />
        <FloatingMessengers />
      </div>
    </LazyMotion>
  );
}

export default App;